import GroupView from './index';
import { useAppSelector } from '../../hooks';
import { RequestState } from '../../interfaces/request';

function GroupContainer() {
  const { groups, state } = useAppSelector((state) => state.groups);
  return (
    <GroupView
      groups={groups}
      isLoading={state === RequestState.INITIAL || state === RequestState.PENDING}
      hasError={state === RequestState.REJECTED}
    />
  );
}

export default GroupContainer;
